import { queryOptions } from '@tanstack/react-query';
import API from '@/api';
import { queryKeys } from '@/api/utils/queryKeys';

export const userTransactionsQueryOptions = () =>
  queryOptions({
    queryKey: queryKeys.transactions,
    queryFn: () => API.user.getUserTransactions(),
  });
